import "./EmergencyButton.css";

function EmergencyButton(){

  return (

    <a 
      href="tel:+27604971899"
      className="emergency-btn"
    >

      <span>☎</span>
      Emergency Call

    </a>

  );

}

export default EmergencyButton;